<div class="card flex flex-col justify-content-center mt-4 w-full">
    <label [for]="inputId" class="mb-2 text-sm font-medium text-black" [class.text-neutral-800]="isDisabled">
        {{ labelText }}
    </label>

    <div class="relative flex items-center">
        <ng-container *ngIf="iconSrc">
            <span class="absolute" [ngStyle]="getIconStyles()">
                <img [src]="iconSrc" [alt]="iconAltText" [ngStyle]="getIconSizeStyles()" />
            </span>
            <span class="absolute" [ngStyle]="getDividerStyles()">
                <div class="h-4 w-[1px] bg-border rounded-full"></div>
            </span>
        </ng-container>
        <textarea [id]="inputId" [placeholder]="placeholder"
            class="border border-border rounded-md py-2 focus:ring-2 focus:ring-primary focus:outline-none w-full resize-none"
            [ngStyle]="getInputPaddingStyles()" [class.border-error]="errorMessage" [rows]="rows" [cols]="cols" [(ngModel)]="textValue"
            [disabled]="isDisabled" [class.text-neutral-800]="isDisabled" (input)="onInputChange($event)"></textarea>
    </div>

    <div *ngIf="errorMessage" class="flex items-center text-error mt-2 text-sm">
        <img src="assets/icons/close-circle.svg" alt="{{ 'shared.components.error_icon' | transloco }}" class="w-5 h-5" />
        <p class="ml-1">{{ errorMessage }}</p>
    </div>
</div>